import { openNotification } from "../../../globals/Components/Notification/Notification";
import { serverMessages, serverMessagesNoOpenNotification } from "../../serverMessages";
import { setErrorMessageResponse, setMessageResponse, toggleErrorIndicator, toggleLoadingIndicator } from "../../system/actions";
import { MessageResponse } from "../../system/types";
import { AppThunk } from "../../thunks";
import { deleteImagenAPI } from "./restCallImagenes";
    

export const deleteImagen = (urlImagen:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteImagenAPI(urlImagen, {});
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false
    }
    else if (responseData.StatusCode === 200) {      
        dispatch(setMessageResponse(null));       
        dispatch(toggleLoadingIndicator(false));
        openNotification("","Imagen eliminada"); 
        return true
    }
    dispatch(toggleLoadingIndicator(false));
};